import React, { useState } from "react";
import styles from "./DownloadModal.module.css";

const DownloadModal = ({ onClose, onDownload, Companyname }) => {
  const [selectedFormat, setSelectedFormat] = useState("pdf"); // default pdf

  const handleFormatChange = (e) => {
    setSelectedFormat(e.target.value);
  };

  const handleDownloadClick = () => {
    onDownload(selectedFormat); // send selected format
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.downloadpdfModalContent}>
        <h3 className={styles.downloadpdfTitle}>{Companyname}</h3>

        {/* Format Selection */}
        <div className={styles.downloadpdfFormatOptions}>
          <label className={styles.downloadpdfFormatLabel}>
            <input
              type="radio"
              name="format"
              value="pdf"
              checked={selectedFormat === "pdf"}
              onChange={handleFormatChange}
            />
            <span className={styles.downloadpdfFormatText}>PDF</span>
          </label>
          <label className={styles.downloadpdfFormatLabel}>
            <input
              type="radio"
              name="format"
              value="excel"
              checked={selectedFormat === "excel"}
              onChange={handleFormatChange}
            />
            <span className={styles.downloadpdfFormatText}>XLS</span>
          </label>
        </div>

        {/* Actions */}
        <div className={styles.downloadpdfActions}>
          <button
            className={styles.downloadpdfButton}
            onClick={handleDownloadClick}
          >
            Download
          </button>
          <button
            className={styles.downloadpdfButton}
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadModal;
